<div
    class="app-container"
    style="height: 100vh; max-width: 99vw">
    <p-toast></p-toast>
    <p-toast key="sticky-toast"></p-toast>
    <!--  navigation component -->

    @if (isLoggedIn()) {
        <app-navigation
            style="height: 100%; box-sizing: border-box"
            (toggleNavigation)="handleToggleNavigation($event)"></app-navigation>
    }

    <!-- rest of the application -->
    <div
        class="main-content"
        [class.navigation-closed]="isNavClosed">
        @if (!isIframe) {
            <router-outlet></router-outlet>
        }
    </div>

    @if (envLabel) {
        <div style="position: fixed; bottom: 1rem; right: 1rem; z-index: 9999">
            <p-badge [value]="envLabel" [style]="{ background: embarkColors.orange }" />
        </div>
    }
</div>
